// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__JWeo4","title":"ClientReferral_title__3SfAV","itemText":"ClientReferral_itemText__qqsyX"};